import CryptoJS from 'crypto-js';

const STORAGE_SECRET = 'hypnotic_local_secret_2026';

export const encryptData = (data: string): string => {
  try {
    return CryptoJS.AES.encrypt(data, STORAGE_SECRET).toString();
  } catch (e) {
    return data;
  }
};

export const decryptData = (encryptedData: string): string => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, STORAGE_SECRET);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    if (!decrypted) return encryptedData;
    return decrypted;
  } catch (e) {
    return encryptedData;
  }
};
